import packageJson from '../../package.json';
const Cookies = require('js-cookie');

export const Version = packageJson.version;

export function DefaultLanguage():string {
    if(Cookies.get("ros_language"))
        return Cookies.get("ros_language") ?? ''
    let userLang = navigator.language || '';
    if (Languages[userLang])
        return userLang;
    return 'esES';
}
export const Languages: any = { 'es': 1, 'en': 2 };

export const LanguageCode = DefaultLanguage();

export const DLValue = 'f37eb162ec29e1751ec39c9256d476ae'

export const APIUrl = packageJson.conf.api_url;

export function MethodActive(method: string) {
    /*method = LocationGroup + '_' + method;
    switch (method) {
        case 'lf_menu_delivery_orders':
        case 'lf_menu_address':
            return false;
    }*/
    return true;
}

export const AWSImageUrl = "https://rosmedia.s3.eu-west-1.amazonaws.com/"
/*
    Files in {StaticUrl}{iCl}/ =>
        icons/
        logo-black.svg
        logo-inline-header.svg
        logo-inline-white.svg
        logo-white.svg
        manifest.json
        style.css
*/
export const StaticUrl = 'https://testing.rosapp.pro/was/';

export function LogoDark(instanceCode:string, size='250'){
    if(size !== '500' && size !== '1000')
        size = '250'
    return `${StaticUrl}${instanceCode}/logo_${size}.webp`
}

export function LogoBlackSVG(instanceCode:string){
    return `${StaticUrl}${instanceCode}/logo-black.svg`
}
export function LogoWhiteSVG(instanceCode:string){
    return `${StaticUrl}${instanceCode}/logo-white.svg`
}

export function LogoInline(instanceCode:string, size='500'){
    if(size === '1000')
        size = '1000x200'
    else
        size = '500x100'
    return `${StaticUrl}${instanceCode}/logo-inline-header_${size}.webp`
}
